var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOrganisation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39836 0.70564C8.17785 0.486792 7.8221 0.486792 7.60159 0.70564L5.26232 3.02732C5.15534 3.1335 5.09517 3.27799 5.09517 3.42872V4.41097H0.982164C0.669826 4.41097 0.416626 4.66418 0.416626 4.97651V15.811C0.416626 16.1234 0.669826 16.3766 0.982164 16.3766H15.0178C15.3301 16.3766 15.5833 16.1234 15.5833 15.811V8.07209C15.5833 7.75975 15.3301 7.50655 15.0178 7.50655H10.9048V3.42872C10.9048 3.27799 10.8446 3.1335 10.7376 3.02732L8.39836 0.70564ZM6.22624 4.97651V3.66423L7.99998 1.90383L9.77371 3.66423V8.07209C9.77371 8.38443 10.0269 8.63763 10.3392 8.63763H14.4522V15.2455H1.5477V5.54205H5.6607C5.97304 5.54205 6.22624 5.28885 6.22624 4.97651ZM4.0972 14.2603H2.53769V12.7125H4.0972V14.2603ZM4.0972 11.1647H2.53769V9.61693H4.0972V11.1647ZM4.0972 8.06914H2.53769V6.52135H4.0972V8.06914ZM7.21623 14.2603V12.7125H8.77575V14.2603H7.21623ZM7.21623 11.1647V9.61693H8.77575V11.1647H7.21623ZM7.21623 8.06914V6.52135H8.77575V8.06914H7.21623ZM7.21623 4.97357V3.42578H8.77575V4.97357H7.21623ZM13.4543 14.2603H11.8948V12.7125H13.4543V14.2603ZM13.4543 11.1647H11.8948V9.61693H13.4543V11.1647Z",
    fill: "#A614B9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrganisation);
export default __webpack_public_path__ + "static/media/Organisation.4e4e78f1ee7d83f98b4528af52112f27.svg";
export { ForwardRef as ReactComponent };